import { render, staticRenderFns } from "./ReporteCreditoBuro.vue?vue&type=template&id=3b1db478&scoped=true&lang=html&"
import script from "./ReporteCreditoBuro.vue?vue&type=script&lang=js&"
export * from "./ReporteCreditoBuro.vue?vue&type=script&lang=js&"
import style0 from "./ReporteCreditoBuro.vue?vue&type=style&index=0&id=3b1db478&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1db478",
  null
  
)

export default component.exports